import React from "react";
import styled from "styled-components";
import { COLOR_SYSTEM, Text } from "components/atoms";
import GroundTruthForm from "./GroundTruthForm";
import { CreateGroundTruthDto } from "services/api/aiReviewTest/groundTruthApi";
import { GroundTruth } from "common/models/types";

interface GroundTruthFormModalProps {
  groundTruth?: GroundTruth;
  onConfirm: (data: CreateGroundTruthDto) => Promise<void>;
  onCancel: () => void;
}

const GroundTruthFormModal: React.FC<GroundTruthFormModalProps> = ({
  groundTruth,
  onConfirm,
  onCancel,
}) => {
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const handleSubmit = async (data: CreateGroundTruthDto) => {
    setIsSubmitting(true);
    try {
      await onConfirm(data);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container>
      <Header>
        <Text textType="H2">{groundTruth ? "Ground Truth 수정" : "Ground Truth 생성"}</Text>
      </Header>

      <Content>
        <GroundTruthForm
          groundTruth={groundTruth}
          onSubmit={handleSubmit}
          onCancel={onCancel}
          isSubmitting={isSubmitting}
        />
      </Content>
    </Container>
  );
};

const Container = styled.div`
  width: 800px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 12px;
`;

const Header = styled.div`
  padding: 16px 0px;
  border-bottom: 1px solid ${COLOR_SYSTEM.get("Gray")?.[200]};
`;

const Content = styled.div`
  padding: 24px 0px 24px 0px;
`;

export default GroundTruthFormModal;
